import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        opacity="0.4"
        d="M43.3701 9.17171C36.8001 0.731714 26.9101 0.691714 24.8301 0.781714C22.7501 0.691714 12.8701 0.731714 6.29009 9.17171C-1.08991 18.6417 0.460085 37.7917 0.460085 37.7917C0.460085 37.7917 4.20009 27.4417 5.08009 20.0717C5.96009 12.6917 10.8001 7.30171 15.4301 6.20171C19.6201 5.20171 21.6801 7.28171 24.8301 7.28171C27.9801 7.28171 30.0401 5.20171 34.2301 6.20171C38.8501 7.30171 43.7001 12.7017 44.5801 20.0717C45.4601 27.4517 49.2001 37.7917 49.2001 37.7917C49.2001 37.7917 50.7501 18.6417 43.3701 9.17171Z"
        fill={fill}
      />
    </g>
  )
}
